import { useState, useEffect, useMemo, useCallback } from "react";


import useSimulacao from "~fetchs/useSimulacao";
import { money } from "~hooks/useHelpers";

const useSimulacaoHook = (simulacao, desconto, cliente) => {
  let simulationId = simulacao?.simulacaoId !== null ? simulacao?.simulacaoId?.toString() : null;
  const { simulacao: simulation } = useSimulacao(false, simulationId);

  const [values, setValues] = useState({
    fracionario: null,
    descarga: null,
  });

  useEffect(() => {
    if (simulacao?.fracionamento !== undefined && simulacao?.descargaManual !== undefined) {
      setValues({
        fracionario: simulacao?.fracionamento,
        descarga: simulacao?.descargaManual,
      });
    }
  }, [simulacao]);

  const atualizarGruposProduto = (simulation, simulacao) => {
    if (!simulacao || !Array.isArray(simulacao.gruposProduto)) {
      return simulation;
    }
    return {
      ...simulacao,
      gruposProduto: simulation.gruposProduto.map((grupoProduto, index) => {
        const grupoProdutoAtualizado = simulacao.gruposProduto[index];
        if (grupoProdutoAtualizado && Array.isArray(grupoProdutoAtualizado.produtos)) {
          return {
            ...grupoProduto,
            produtos: grupoProduto.produtos.map((produto, prodIndex) => {
              const produtoAtualizado = grupoProdutoAtualizado.produtos[prodIndex];
              return produtoAtualizado ? { ...produto, quantidade: produtoAtualizado.quantidade } : produto;
            }),
          };
        }
        return grupoProduto;
      }),
    };
  };

  const getTodayDate = () => {
    const date = new Date();
    const months = [
      "janeiro", "fevereiro", "março", "abril", "maio", "junho",
      "julho", "agosto", "setembro", "outubro", "novembro", "dezembro",
    ];
    return `${date.getDate()} de ${months[date.getMonth()]} de ${date.getFullYear()}`;
  };

  const simulacaoAtualizada = useMemo(
    () => atualizarGruposProduto(simulation, simulacao),
    [simulation, simulacao]
  );

  const grupos = simulacaoAtualizada?.gruposProduto?.length ? simulacaoAtualizada.gruposProduto : simulacaoAtualizada?.gruposMateriais || [];
  const todosOsProdutos = grupos.reduce((acc, grupo) => acc.concat(grupo.produtos), []);

  const calcCif = useCallback((preco, quantidade, produto) => {
    preco = Number(parseFloat(preco || 0).toFixed(2));
    const { pesoLiquido: peso } = produto?.produtoOriginal || {};
    const fracionamento = parseFloat(produto?.fracionamento);
    const fracionamentoValor = peso && fracionamento ? (fracionamento / 1000) * parseFloat(peso) : fracionamento;
    const descargaValor = produto?.descargaManual;
    return quantidade > 0
      ? money((preco + (values.fracionario ? fracionamentoValor : 0) + (values.descarga ? descargaValor : 0) + (produto?.beneficioFis?.cif || 0)) * quantidade)
      : "-";
  }, [values.fracionario, values.descarga]);

  const calcCifModal = useCallback((precoCif, item) => {
    const fracionamento = parseFloat(item?.fracionamento) || 0;
    const peso = parseFloat(item?.produtoOriginal?.pesoLiquido) || 0;
    const fracionamentoValor = peso && fracionamento ? (fracionamento / 1000) * peso : fracionamento;
    const descargaValor = parseFloat(item?.descargaManual) || 0;
    const preco = parseFloat(precoCif) || 0;
    const beneficioCif = parseFloat(item?.beneficioFis?.cif) || 0;

    return money(
      (values.fracionario ? fracionamentoValor : 0) +
      (values.descarga ? descargaValor : 0) +
      preco +
      beneficioCif
    );
  }, [values.fracionario, values.descarga]);



  return {
    simulacaoAtualizada,
    grupos,
    todosOsProdutos,
    getTodayDate,
    calcCif,
    calcCifModal,
    atualizarGruposProduto,
    simulation,
    values,
    setValues
  };
};

export default useSimulacaoHook;
